// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 320px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "(max-width: 1024px)";
var _5 = "(max-width: 768px)";
var _6 = "promoNotificationWrapper-eQOqG";
var _7 = "content-YdR1_";
var _8 = "title-2Sxat";
var _9 = "text-1yVr0";
export { _1 as "__esModule", _2 as "iphone5", _3 as "mobile", _4 as "tablet", _5 as "tabletMiddle", _6 as "promoNotificationWrapper", _7 as "content", _8 as "title", _9 as "text" }
export default { "__esModule": _1, "iphone5": _2, "mobile": _3, "tablet": _4, "tabletMiddle": _5, "promoNotificationWrapper": _6, "content": _7, "title": _8, "text": _9 }
